<template>
  <div class="active-filters" :key="update_key" v-if="has_active_filters">
    <div class="active-filters__row">
      <div class="active-filters__brand">
        <div
          class="active-filters__brand-item"
          v-for="(option, option_index) in filters.brand"
          :key="`brand_${option_index}`"
        >
          <div class="active-filters__brand">
            <vb-checkbox
              @change="(value) => $emit('filter', { key: 'brand', value })"
              v-model="option.selected"
              v-show="option.selected"
              :vb_options="{
                text: `${option.text} (${option.amount})`,
                value: option.selected,
              }"
            >
              <template #default>
                <div class="active-filters__brand-label">
                  <img :src="`assets/images/alpitour/liveat-brands/${option.logo}`" />&nbsp;&nbsp;({{ option.amount }})
                </div>
              </template>
            </vb-checkbox>
          </div>
        </div>
      </div>
      <div class="active-filters__non_brand">
        <div
          class="active-filters__non_brand-item"
          v-for="(filter, filter_key) in non_brand_filters"
          :key="`btn_${filter_key}`"
        >
          <template v-for="(option, option_index) in filter">
            <b-badge
              v-if="option.selected"
              :key="`btn_${filter_key}_${option_index}`"
              pill variant="primary"
              class="active-filters__chip semibold d-inline-flex mr-1 cursor-pointer mb-1"
              @click="() => {
                option.selected = false
                $emit('filter', { key: filter_key, value: false })
              }"
            >
              <div>{{ `${option.text} (${option.amount})`.toLowerCase() }}</div>
              <div class="ml-2">&#10005;</div>
            </b-badge>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get_non_brand_filters } from '@alpitour/utilities/results-filters'

export default {
  name: "active-filters",
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
    update_key: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    non_brand_filters() {
      return get_non_brand_filters(this.filters)
    },
    has_active_filters() {
      const brand_active = (this.filters.brand || []).some((o) => o.selected)
      if (brand_active) return true
      return Object.values(this.non_brand_filters).some(
        (options) => options.some((o) => o.selected),
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.active-filters {
  margin-bottom: $grid-gutter-width;
  display: flex;
  justify-content: center;

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__non_brand {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    margin-left: $grid-gutter-width;
  }

  &__chip {
    text-transform: capitalize;
  }

  &__brand {
    padding-left: 0;

    img {
      margin-left: 0.15rem;
      height: 16px;
      width: auto;
    }
  }

  &__brand-label {
    display: flex;
    align-items: center;
  }
}
</style>
